import type {SchedulerTemplateForm} from 'src/types/scheduler/template-form';
import type {SchedulerTemplateFormActions} from 'src/action-creators/scheduler/template-form';

import {
  SET_TEMPLATE_FORM,
  UPDATE_TEMPLATE_FORM,
} from 'src/action-creators/scheduler/template-form';


export const initialState: SchedulerTemplateForm = {
  id: '',
  name: '',
  brandId: '',
  usages: [],
  linkUrl: '',
  agentId: '',
  timezone: '',
  location: '',
  urlSuffix: '',
  language: 'en',
  duration: {amount: 30, unit: 'minutes'},
  description: '',
  ccEmailIds: [],
  bufferTime: {amount: 0, unit: 'minutes'},
  linkUrlShort: '',
  maxEventSize: 0,
  capacity: [],
  futureLimit: {amount: 30, unit: 'days'},
  maxEventsPerDay: 0,
  isTeamTemplate: false,
  sendEventBookingSms: false,
  locationMeta: [],
  eventReminders: [],
  cancellationPolicy: '',
  minBookingNotice: {amount: 1, unit: 'days'},
  sendEventBookingEmail: false,
  minCancellationNotice: {amount: 1, unit: 'days'},
  openBookingSlots: [],
  bookingAccounts: [],
  requireBookingConfirmation: false,
  overrideCalendarAvailability: false,
  distributionRule: 'single_account',
  additionalQuestions: [],
  eventConfirmationNotifications: {
    cancelEvent: [],
    scheduleEvent: [],
    rescheduleEvent: [],
    requestRescheduleEvent: [],
  },
  templateType: 'standard',
  assignments: {
    agents: 0,
    securityGroups: 0,
    isAssignedToAll: false,
  },
  workingAssignments: {
    isAssignedToAll: false,
    inclusions: {
      agentIds: [],
      securityGroupIds: [],
    },
    exclusions: {
      agentIds: [],
      securityGroupIds: [],
    },
  },
};

export default (
  state: SchedulerTemplateForm | null | undefined = initialState,
  action: SchedulerTemplateFormActions,
): SchedulerTemplateForm => {
  switch (action.type) {
    case SET_TEMPLATE_FORM:
      return {...state, ...action.payload};
    case UPDATE_TEMPLATE_FORM:
      const {field, value} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ id?: string | undefined; name?: string | undefined; brandId?: string | undefined; usages?: Usage[] | undefined; linkUrl?: string | undefined; agentId?: string | undefined; timezone?: string | undefined; ... 30 more ...; eventConfirmationNotifications?: EventConfirmationNotifications | undefined; }' is not assignable to type 'Template'.
      return {
        ...state,
        [field]: value,
      };
    default:
      // @ts-expect-error - TS2322 - Type 'Template | null' is not assignable to type 'Template'.
      return state;
  }
};
